module.exports = __webpack_public_path__ + "img/icon-heart-green.3ef54f59.svg";